import { ReactNode } from 'react'
import { mtc } from '../../../utils/style-helpers'
import { styles } from './styles'

export enum HeadingColors {
  DEFAULT_TEXT = 'default-text',
  DISABLED_TEXT = 'disabled-text',
  EMPHASIS_TEXT = 'emphasis-text',
  HEADER_TEXT = 'header-text',
  LINK_TEXT = 'link-text',
  MUTED_TEXT = 'muted-text',
  DANGER = 'danger',
  BRAND = 'brand',
  PRIORITY = 'priority',
}

export enum HeadingVariants {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
}

interface IHeadingProps {
  /** DEPRECATED: Use `variant` instead */
  as?: HeadingVariants
  children?: ReactNode
  className?: string
  color?: HeadingColors
  textAlign?: 'center' | 'left' | 'right'
  variant?: HeadingVariants
}

export const Heading = ({
  as,
  children,
  className,
  color,
  textAlign,
  variant,
}: IHeadingProps) => {
  if (!variant && as) {
    variant = as
  }

  const Comp = variant ? variant : ('h1' as const)

  return (
    <Comp className={mtc(styles({ textAlign, color, variant }), className)}>
      {children}
    </Comp>
  )
}

Heading.displayName = 'Heading'
